import React from "react";

import "./Qualities.scss";
import { ReactSVG } from "react-svg";

const Qualities = () => {
  const array = [
    {
      headline: "HIPAA Compliant",
      tagline: "Ensure privacy and security",
      icon: "/icons/tools/hipaa.svg",
    },
    {
      headline: "Expert Consultant",
      tagline: "Certified online advisor",
      icon: "/icons/tools/consultant.svg",
    },
    {
      headline: "no insurance No problem ",
      tagline: "Easily Accessable",
      icon: "/icons/tools/hipaa.svg",
    },
  ];

  return (
    <div className="qualities-section">
      {array.map((item) => {
        return (
          <div className="quality-item">
            <ReactSVG src={item.icon} />
            <div>
              <h3>{item.headline}</h3>
              <h5>{item.tagline}</h5>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Qualities;
